import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Bundle Selection", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_app_checkbox = _resolveComponent("app-checkbox")!
  const _component_app_modal = _resolveComponent("app-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_card, { label: "Function" }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_app_button, {
            name: "Search",
            icon: "fa-search",
            theme: "info",
            disabled: _ctx.v$.$invalid,
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.fetchList(0)), ["prevent"]))
          }, null, 8, ["disabled"]),
          (_ctx.query.categoryId)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Add item",
                icon: "fa-plus",
                theme: "info",
                to: { name: _ctx.ROUTE_NAME_AVATAR.ITEM.ADD, query: { categoryId: _ctx.query.categoryId } }
              }, null, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_app_form_row, {
          label: "Name",
          class: "col-md-6 mx-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              modelValue: _ctx.query.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.name) = $event)),
              validations: _ctx.v$.query,
              placeholder: "Please enter at least 3 characters"
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, {
          label: "Is new",
          class: "col-md-6 mx-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              options: _ctx.IsNewOptions,
              modelValue: _ctx.query.isNew,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.isNew) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_app_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_table, {
          rows: _ctx.list,
          total: _ctx.total,
          offset: _ctx.query.offset,
          limit: _ctx.query.limit,
          columns: _ctx.table.columns,
          actions: _ctx.table.actions,
          onRefreshData: _ctx.fetchList
        }, null, 8, ["rows", "total", "offset", "limit", "columns", "actions", "onRefreshData"])
      ]),
      _: 1
    }),
    _createVNode(_component_app_modal, { name: _ctx.BUNDLE_LINK_MODAL_NAME }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bundleSelection.linkableBundles, (bundle) => {
          return (_openBlock(), _createBlock(_component_app_checkbox, {
            key: bundle,
            type: "icheck",
            label: bundle.name,
            modelValue: bundle.hasLinked,
            "onUpdate:modelValue": ($event: any) => ((bundle.hasLinked) = $event)
          }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
        }), 128)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_app_button, {
            name: "Ok",
            theme: "success",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.actions.linkBundle()), ["prevent"]))
          }),
          _createVNode(_component_app_button, {
            name: "Cancel",
            theme: "secondary",
            onClick: _withModifiers(_ctx.actions.closeLinkBundle, ["prevent"])
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["name"])
  ], 64))
}